module.exports = {
	"pathContext": {
		"path": "/shop/merino-chunky-blanket/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop-merino-chunky-blanket.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop-merino-chunky-blanket.json
// module chunks = 65140105295766